import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';
import { CKEditor4, CKEditorComponent } from 'ckeditor4-angular';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';

declare var decimalInput: any;
declare function disableHighlightEditor(): any
declare function reAddStyling(): any;

@Component({
  selector: 'app-highlight',
  templateUrl: './highlight.html',
  styleUrls: ['./highlight.scss']
})

export class Highlight implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public questionText = "";
  public questionId = 0;
  public allClosed = true;
  public ckeConfig:any;

  private loadAnswersSubscription : Subscription;
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
     this.ckeConfig = {
      extraPlugins:'colorbutton',
      toolbarGroups:[
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
       ],
      colorButton_colors: 'f1e740,ffffff',
      colorButton_enableAutomatic : false,
      colorButton_enableMore : false,
      colorButton_foreStyle : false,
      //readOnly: true
    };

    this.ckeConfig.removeButtons = 'Styles,Format,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Redo,Find,Undo,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Link,Unlink,Anchor,Table,Flash,Image,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,Bold,Font,FontSize,Underline,Italic,NumberedList,BulletedList,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,TextColor,ExportPdf';

    this.loadAnswersSubscription = this.dataSvc.getLoadHighlightAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {
    if(this.dataSvc.currentQuestion.Question.QuestionType !== 1029) return;

    if(this.dataSvc.currentQuestion.Result.Selection != "" && this.dataSvc.currentQuestion.Result.Selection != this.dataSvc.currentQuestion.Question.QuestionText){
      this.questionText = this.dataSvc.currentQuestion.Result.Selection;
    }
    else{
      this.questionText = this.dataSvc.currentQuestion.Question.QuestionText;
    }

  }

  disableKeys(event: CKEditor4.EventInfo){
    event.editor.on("key", function(evt){
      evt.cancel();
    })
    var textcolor = <HTMLAnchorElement>document.querySelectorAll("cke_button__textcolor")[0];
    if(textcolor !== null && textcolor !== undefined){
      textcolor.style.display = "none";
    }
  }

  saveQuestion( event: CKEditor4.EventInfo){
    
    event.editor.on("key", function(evt){
      evt.cancel();
    })
    var editor = event.editor;
    var data = editor.getData();
		this.dataSvc.currentQuestion.Result.Selection = data;    
	}

  cancelDrag(event: CKEditor4.EventInfo){
    this.yesReset();
    return false
  }

  resetQuestion(){    
    document.getElementById("highlightModal").style.display = "block";
    document.getElementById("highlightModal").classList.add("show");
  }

  yesReset(){
    this.questionText = this.dataSvc.currentQuestion.Question.QuestionText;    
    this.dataSvc.currentQuestion.Result.Selection = "";      
    this.closeHighlightModal();
    setTimeout(() => {
      reAddStyling();
    },100)
    
  }

  closeHighlightModal(){
    document.getElementById("highlightModal").style.display = "none";
    document.getElementById("highlightModal").classList.remove("show");

  }

 
}
